// removed by extract-text-webpack-plugin
module.exports = {"mainWrapper":"mainWrapper__3m1QN","percentageBarWrapper":"percentageBarWrapper__JFMWG","percentageBar":"percentageBar__3w2ri"};


//////////////////
// WEBPACK FOOTER
// ./components/tmp_progress_bar/style.scss
// module id = 2QlQ
// module chunks = 0